import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const TramIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.36333 1C4.72221 1 3.33256 2.2105 3.10747 3.83611L2.15072 10.746C2.05836 11.413 2.3487 12.0754 2.90181 12.4595C3.49315 12.8701 4.1217 13.2016 4.7731 13.4538L4 15H5.5L6.07649 13.847C7.49209 14.1586 8.96688 14.122 10.3685 13.7371L11 15H12.5L11.6408 13.2816C12.1451 13.0566 12.6333 12.7825 13.0985 12.4595C13.6516 12.0754 13.942 11.413 13.8496 10.746L12.8929 3.8361C12.6678 2.2105 11.2781 1 9.637 1H6.36333ZM4.91259 4.21391C4.44986 4.25061 4.07197 4.60566 3.99832 5.07292L3.50217 8.22083C3.48835 8.30852 3.54187 8.39266 3.62603 8.41554C6.49194 9.19482 9.50806 9.19482 12.374 8.41554C12.4581 8.39266 12.5117 8.30852 12.4978 8.22083L12.0017 5.07292C11.928 4.60566 11.5501 4.25061 11.0874 4.21391L8.77926 4.03085C8.26054 3.98972 7.73946 3.98972 7.22074 4.03085L4.91259 4.21391ZM6.44317 11.763C6.21807 12.12 5.38947 12.0678 4.59243 11.6464C3.79539 11.225 3.33174 10.594 3.55683 10.237C3.78193 9.88004 4.61053 9.93221 5.40757 10.3536C6.20461 10.775 6.66826 11.406 6.44317 11.763ZM11.4076 11.6464C10.6105 12.0678 9.78193 12.12 9.55683 11.763C9.33174 11.406 9.79539 10.775 10.5924 10.3536C11.3895 9.93221 12.2181 9.88004 12.4432 10.237C12.6683 10.594 12.2046 11.225 11.4076 11.6464ZM6 2.88889C6 2.39797 6.39797 2 6.88889 2H9.11111C9.60203 2 10 2.39797 10 2.88889C10 2.95025 9.95025 3 9.88889 3H6.11111C6.04975 3 6 2.95025 6 2.88889Z"
		></path>
	</svg>
))
